import React from 'react';
import { t } from '@lingui/core/macro';
import { Select } from '@ygtechnologies/bygr-frontend-component-library';
import { useProjectTags } from '@/services/project-tags';
import { ProjectTagType } from '@/types';

interface ProjectTagSelectProps {
    projectId: number;
    value: number | null;
    onChange(projectTagId: number | null): void;
    isDisabled?: boolean;
}

/**
 * Single-select for a non-room project tag (the generic "Tag" concept,
 * fetched with {@link ProjectTagType.Room}). Clearable; emits null when cleared.
 */
export const ProjectTagSelect: React.FC<ProjectTagSelectProps> = ({
    projectId,
    value,
    onChange,
    isDisabled = false,
}) => {
    const { data: tags } = useProjectTags(projectId, ProjectTagType.Room);

    const options = (tags ?? []).map((tag) => ({ label: tag.label, value: tag.id }));

    return (
        <Select
            isDisabled={isDisabled}
            isClearable
            fieldName={t`Tag`}
            placeholder={t`Select tag`}
            noOptionsMessage={() => t`No tags created yet`}
            onChange={(nw: any) => onChange(nw ? nw.value : null)}
            value={options.find((o) => o.value === value) || null}
            options={options}
        />
    );
};
